export default {
  props: {
    size: {
      type    : Number | String,
      default : '36'
    },
    color: {
      type    : String,
      default : '#2c3b48'
    },
    customStyle: {
      type    : String | Object,
      default : ''
    }
  }
};
